import { CareEnvironment } from './appModel';

// Capability predicates for care environments — a single home for the domain
// rules that used to be scattered `env === CareEnvironment.home` checks, so
// Independent Living (home-style care + out-of-pocket room & board under the
// claim-projection engine) can share the home code paths. See
// docs/il-payout-modeling-plan.md.

// Environment carrying an out-of-pocket room & board cost separate from the
// policy-eligible care cost. Independent living splits into home-style care
// (covered) plus room & board (out-of-pocket); assisted living and full-care
// facilities bundle room & board into their single covered monthly rate.
export function hasSeparateRoomAndBoard(careEnvironment: CareEnvironment): boolean {
  return careEnvironment === CareEnvironment.independentLiving;
}

// Environments whose care runs the onboarding family-caregiving hours step:
// home, and Independent Living, whose care is home-style (professional hours the
// family can offset) plus a separate out-of-pocket room & board line. Every other
// facility bundles care into a flat monthly rate with no family offset, so it
// skips the step. Used by BOTH the onboarding slide-sequence filter and the
// care-settings next-slide routing, so the two can never disagree about whether
// the step is reachable.
export function usesFamilyCaregivingStep(
  careEnvironment: CareEnvironment | null | undefined,
  useClaimProjectionEngine: boolean,
): boolean {
  if (careEnvironment == null) {
    return false;
  }
  return (
    careEnvironment === CareEnvironment.home ||
    (useClaimProjectionEngine && hasSeparateRoomAndBoard(careEnvironment))
  );
}
